import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import React from "react";

const RefundIcon = () => <FontAwesomeIcon icon={["fas", "dollar-sign"]}/>

export default RefundIcon;